import { isObject } from '../../type_guards'
import { joi } from '@nhtio/lucid-resourceful/joi'
import {
  SchemaOrReferenceObjectSchema as schemaOrReferenceObjectSchema,
  ParameterObjectSchema as parameterObjectSchema,
} from '../utils/openapi_validation_schemas'
import type { RouteCallback, AdditionalResourcefulRouteDetails } from '../types'

const RouteCallbackSchema = joi.function<RouteCallback>().required()

const AdditionalResourcefulRouteDetailsSchema = joi.object<AdditionalResourcefulRouteDetails>({
  title: joi.string().optional(),
  description: joi.string().optional(),
  handler: RouteCallbackSchema,
  parameters: joi.array().items(parameterObjectSchema).optional(),
  requestPayloadSchema: schemaOrReferenceObjectSchema.optional(),
  responsePayloadSchema: schemaOrReferenceObjectSchema.optional(),
  tags: joi.alternatives(joi.string(), joi.array().items(joi.string())).optional(),
})

export const isAdditionalResourcefulRouteDetails = (
  value: unknown
): value is AdditionalResourcefulRouteDetails => {
  if (!isObject(value)) {
    return false
  }
  const { error } = AdditionalResourcefulRouteDetailsSchema.validate(value, { abortEarly: true })
  return !error
}
